new Vue({
  delimiters: ['[[', ']]'], // change because vue and django using the same args 
  el: '#app_header',
  data: {
    header: {
      Position: 'fixed',
      useFirst: true, // first headerBar

      myaccount_options: 'dropdown', // 'none' = no dropdowns, 'dropdown' = hover and dropdown menu;

      isNavUp: true,
      lastScrollTop: 0,

      menuMobile: false,
    },
    searchOpened: false,
    cartOpened: false,
    view_origin_home: (view_origin == 'home') ? true : false
  },
  computed: {
    headerClasses() {
      return {
        'nav-up': this.header.isNavUp,
        [this.header.Position]: true
      };
    }
  },
  created() {
    window.addEventListener("resize", this.screenHandler);
  },
  destroyed() {
    window.removeEventListener("resize", this.screenHandler);
  },
  methods: {
    screenHandler() {
      this.mobile = (window.innerWidth > 991) ? false : true;
    },

    addPaddingHeader() {
      // .header--solid: transparência desligada no admin, a home recebe o padding do header como as outras páginas
      const headerTransparent = document.querySelector('.nav-up:not(.header--solid)');
      const header = document.querySelector('header[data-role="heading"]');
      const headerHeight = header.clientHeight;
      const mainTag = document.querySelector('main[role="main"]');
      const mainDiv = document.querySelector('.main-content');
      const bread = document.querySelector('.breadcrumb')
      const productDetail = document.querySelector('#product-detail');

      // on product detail mobile the top breadcrumb (.product-detail__breadcrumb) is
      // hidden by css and the visible one sits below the photo, so the header height
      // has to be compensated on .main-content itself
      if (productDetail && window.innerWidth <= 991) {
        productDetail.setAttribute("style", `padding-top:${headerHeight}px !important`);
        if (bread) {
          bread.setAttribute("style", `margin-top:0px !important`);
        }
        return;
      }

      if (headerTransparent) {
        if (view_origin != "home") {
          if (mainTag) {
            mainTag.setAttribute("style", `padding-top:${headerHeight}px !important`);
          } else if (mainDiv && bread) {
            if ($(bread).css('display') == 'none') {
              mainDiv.setAttribute("style", `padding-top:${headerHeight}px !important`)
              bread.setAttribute("style", `margin-top:0px !important`);
            } else {
              mainDiv.setAttribute("style", `padding-top:0px !important`)
              bread.setAttribute("style", `margin-top:${headerHeight}px !important`);
            }
          } else if (mainDiv) {
            mainDiv.setAttribute("style", `padding-top:${headerHeight}px !important`)
          } else if (bread) {
            bread.setAttribute("style", `margin-top:${headerHeight}px !important`);
          }
        }
      } else {
        if (mainTag) {
          mainTag.setAttribute("style", `padding-top:${headerHeight}px !important`);
        } else if (mainDiv && bread) {
          if ($(bread).css('display') == 'none') {
            mainDiv.setAttribute("style", `padding-top:${headerHeight}px !important`)
            bread.setAttribute("style", `margin-top:0px !important`);
          } else {
            mainDiv.setAttribute("style", `padding-top:0px !important`)
            bread.setAttribute("style", `margin-top:${headerHeight}px !important`);
          }
        } else if (mainDiv) {
          mainDiv.setAttribute("style", `padding-top:${headerHeight}px !important`)
        } else if (bread) {
          bread.setAttribute("style", `margin-top:${headerHeight}px !important`);
        }
      }
    },

    runSpeechRecognition() {
      var isChromium = window.chrome;
      var winNav = window.navigator;
      var vendorName = winNav.vendor;
      var isOpera = typeof window.opr !== "undefined";
      var isIEedge = winNav.userAgent.indexOf("Edge") > -1;
      var isIOSChrome = winNav.userAgent.match("CriOS");

      if (isChromium !== null && typeof isChromium !== "undefined" && vendorName === "Google Inc." && isOpera === false && isIEedge === false) {
        let output = document.querySelector(".output-search");
        let action = document.querySelector(".microphone");
        let inputMic = document.querySelector(".search__text");

        var SpeechRecognition = SpeechRecognition || webkitSpeechRecognition;

        var recognition = new SpeechRecognition();
        recognition.continuous = false;
        recognition.lang = 'pt-BR';


        recognition.onstart = function () {
          if (!output.classList.contains("hide")) {
            output.classList.toggle("hide");
          }

          action.classList.toggle('active');
        };

        recognition.onspeechend = function () {

          action.classList.toggle('active');
          recognition.stop();
        }

        recognition.onresult = function (event) {
          var transcript = event.results[0][0].transcript;
          var confidence = event.results[0][0].confidence * 100;

          if (confidence < 50) {
            inputMic.classList.toggle('not-understand')
            output.classList.toggle("hide");
            inputMic.value = "Desculpe não entendi muito bem.";
          } else {
            inputMic.value = transcript
            document.querySelector('.button-busca').click()
          };

        };

        // start recognition
        recognition.start();
      } else return document.querySelector(".microphone-search").remove();
    },

    handleScroll() {
      const st = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;

      if (st > this.lastScrollTop)
        this.header.isNavUp = false;
      else {
        if (st === 0)
          this.header.isNavUp = true;
      }

      this.lastScrollTop = st;
    },
  },
  mounted() {
    $('#js-texto-header').slick({
      arrows: false,
      infinite: false,
      autoplay: true,
      autoplaySpeed: 3000,
      dots: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 1000,
      mobileFirst: true,
    });

    this.addPaddingHeader();

    window.addEventListener('scroll', this.handleScroll);

    const helpMe = document.querySelector('.help-me');
    if (helpMe) {
      helpContent = helpMe.querySelector('.help-me-content');
      helpGroup = helpMe.querySelector('.help-me-group');
      if (helpContent && helpGroup) {
        const open = helpMe.querySelector('.help-me-group-open');
        open.addEventListener('click', () => {
          let openTitle = helpMe.querySelector('.help-me-group-open .open-title');
          let openClose = helpMe.querySelector('.help-me-group-open .close');
          helpContent.classList.toggle('active');
          open.classList.toggle('active');
          openTitle.classList.toggle('active');
          openClose.classList.toggle('active');
        })
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  }
})

/* Mobile Wrapper */
const mobileNavLinks = document.querySelectorAll('.mobile-nav__link.ewrap');

mobileNavLinks.forEach(link => {
  link.addEventListener('click', function (event) {
    event.preventDefault();
    this.classList.toggle('active');
    const wrapper = this.nextElementSibling;
    if (wrapper && wrapper.tagName === 'UL') {
      wrapper.classList.toggle('active');
    }
  });
});

var cart_preview_triggers = $('.header__second--tools-cart, .cart-preview-header__close, .cart-preview--overlay, .cart-preview .btn-continue');

cart_preview_triggers.on("click", function (e) {
  $('.cart-preview').toggleClass('active');
  $('.cart-preview--overlay').toggleClass('active');
  document.body.classList.toggle('no-scroll');
  document.documentElement.classList.toggle('no-scroll');
});

const btnContinue = document.querySelector('.cart-preview .btn-continue');
if (btnContinue) {
  btnContinue.addEventListener('click', () => {
    $('.cart-preview').removeClass('active');
    $('.cart-preview--overlay').removeClass('active');
    $('.cart-preview').removeClass('cupom-active');
    $('.cart-preview--overlay').removeClass('cupom-active');
    document.body.classList.remove('no-scroll');
  });
}